module.exports = __webpack_public_path__ + "packs/media/images/lexiqamus-logo-f035416273c0ad27e5c434add188d731.png";